import { render, staticRenderFns } from "./FinanceReportsBalances.vue?vue&type=template&id=83b99cc4&"
import script from "./FinanceReportsBalances.vue?vue&type=script&lang=js&"
export * from "./FinanceReportsBalances.vue?vue&type=script&lang=js&"
import style0 from "./FinanceReportsBalances.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports